
export default {
  data() {
    return {
      isSticky: false,
      potentials: [
        {
          icon: require("~/assets/img/icon-satellite.png"),
          alt: "icone yeux etoile",
          title: "+ de 15 000 entreprises",
          text: "propulsées dans leur communication",
        },
        {
          icon: require("~/assets/img/icon-idee.png"),
          alt: "icone ampoule allumé",
          title: "+ de 5 000 sites web",
          text: "conçus par nos équipes de webdesign",
        },
        {
          icon: require("~/assets/img/icon-orbit.png"),
          alt: "icone licorne",
          title: "+ de 100 métiers",
          text: "différents accompagnés chaque jour",
        },
      ],
      testimonials: [
        {
          img: require("~/assets/img/testimonials/testi-y-toitures.png"),
          tags: [0],
          text: "Je suis très content de leurs services. Toujours à l’écoute et prêts à nous aider. Je recommande pour tout développement dans le domaine internet. Merci à toute l’équipe.",
          author: "Yves HUMMEL — Y Toitures",
        },
        {
          img: require("~/assets/img/testimonials/testi-atc-home.jpg"),
          tags: [0, 2],
          text: "Merci à toute l’équipe pour votre réactivité et votre professionnalisme. Merci à Jamel pour son écoute et son accompagnement au sein de nos projets.",
          author: "Adrien ADAM - ATC Home",
        },
        {
          img: require("~/assets/img/testimonials/testi-gt-autos.jpg"),
          tags: [3, 0, 2],
          text: "Cela fait 3 ans que notre société travaille avec ALEO et ils sont toujours aussi sympathiques et professionnels. Nous leur avons confié ce jour notre site internet ainsi que nos cartes de visite et je suis sûre du résultat, il sera parfait.",
          author: "Cindy TABTI - GT AUTOS MOTORCRAFT",
        },
      ],
      faq: [
        {
          question: "Que contient la maintenance technique du site web ?",
          answer:
            "Chez ALEO, nos experts en création de site web assurent la maintenance technique de ton site. Nous mettons à jour les éléments techniques de ton site vitrine, les différents éléments techniques qui le composent, mais également l’infrastructure qui le supporte. Autrement dit, nos équipes ALEO font en sorte que ton site web se porte bien.",
          isCollapsed: false,
        },
        {
          question:
            "J’ai déjà un nom de domaine pour mon site internet, comment faire ?",
          answer:
            "Tu possèdes déjà un nom de domaine et tu souhaites le rediriger vers ton nouveau site internet ? Nos experts seront à même de le reprendre : tu conserveras ainsi son historique, mais aussi une continuité de services. Chaque situation étant différente, un membre de l’équipe web ALEO prendra contact avec toi pour faire le point sur ta demande et te conseiller de la meilleure des manières.",
          isCollapsed: false,
        },
        {
          question:
            "Quelles sont les étapes de la création de mon futur site internet ?",
          answer:
            "Dans un premier temps, un expert en communication numérique prend contact avec toi afin de recueillir un maximum d’informations sur ton activité et te conseillera sur les éléments à mettre en avant sur ton site. Préparation de base (spatiale) : nos webdesigners et rédacteurs prennent le relai sur ton site internet et t’envoient une première version. S’ensuivent échanges et remarques afin que ton site corresponde au max à tes cibles et ton activité. Décollage imminent : mise en ligne de ton site internet sur le nom de domaine public final. Pilotage automatique activé, direction les étoiles. ",
          isCollapsed: false,
        },
        {
          question:
            "Puis-je valider la maquette de mon site internet avant sa mise en ligne ?",
          answer:
            "Pour que ton site vitrine soit le plus accordé à ton image, il est évident pour nous que tu doives garder un œil dessus ! Tu recevras la maquette de ton site internet avant sa publication sur laquelle nous te conseiller vivement de donner ton avis. Reste pilote de ta communication et maintiens le cap de ta visibilité.",
          isCollapsed: false,
        },
        {
          question: "Comment confier la création de mon site web à ALEO ?",
          answer:
            "Tu souhaites confier la création de ton site vitrine à ALEO ? Pour cela, tu peux nous contacter en remplissant notre formulaire de contact, prendre rendez-vous dans l’agenda d’un de nos conseillers, ou bien nous appeler au 01 84 74 17 17 !",
          isCollapsed: false,
        },
        {
          question:
            "J'ai déjà un site vitrine, puis-je quand même faire appel à ALEO ?",
          answer:
            "Si tu as déjà un site internet et du contenu que tu souhaites conserver, nos équipes s’occupent de récupérer les éléments que tu souhaites conserver pendant la migration. Nous faisons en sorte d’assurer une continuité entre ton ancien et ton nouveau site vitrine pour que tu puisses conserver ton image de marque.",
          isCollapsed: false,
        },
        {
          question:
            "Est-ce que mon site internet sera compatible avec les appareils mobiles et tablettes?",
          answer:
            "En confiant la création de ton site web à ALEO, notre équipe t’assure une navigation optimisée sur tous les supports (ordinateur, tablette et téléphone). Nous faisons en sorte que ta vitrine puisse être consultée par tous tes clients, peu importe où ils se trouvent et la qualité de leur connexion, pour que tu puisses obtenir un maximum d’opportunités pour ton projet !",
          isCollapsed: false,
        },
        {
          question:
            "Pourrais-je modifier mon site internet ALEO après sa création ?",
          answer:
            "Ton site internet évolue en même temps que ton entreprise ! C'est pourquoi nous te proposons chez ALEO de modifier le contenu de ton site de manière ponctuelle afin qu'il représente au mieux ton activité !",
          isCollapsed: false,
        },
      ],
      offerItems: [
        {
          title: "Site web",
          price: "49€",
          perMonth: true,
          text: `Boostez votre activité grâce à <br class="hidden lg:block"> votre site internet clé en main.`,
          link: "web",
          img: "offer-web.webp",
          alt: "Exemple de site internet",
        },
        {
          title: "Réseaux sociaux",
          price: "290€",
          perMonth: true,
          text: `Développez votre notoriété et gagnez en <br class="hidden lg:block"> crédibilité pour attirer de nouveaux clients.`,
          link: "gestion-rs",
          img: "offer-cm.png",
          alt: "Exemples de posts Facebook ou Instagram",
        },
        {
          title: "Publicité Google",
          price: "299€",
          perMonth: true,
          text: `Générez plus de contacts en <br class="hidden lg:block"> passant de visible à incontournable.`,
          link: "seo",
          img: "offer-seo.webp",
          alt: "Landing page campagne Google Ads",
        },
        {
          title: "Graphisme",
          price: "199€",
          perMonth: false,
          text: `Différenciez-vous et marquez les esprits de vos <br class="hidden lg:block"> clients avec une image professionnelle.`,
          link: "graphism",
          img: "offer-graphism.webp",
          alt: "Exemple de cartes de visite et logo ALEO",
        },
      ],
    };
  },

  head() {
    return {
      title: "ALEO - la solution pour une image pro",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Démarre ton activité avec les outils essentiels à ta réussite !",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "ALEO - la solution pour une image pro",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Démarre ton activité avec les outils essentiels à ta réussite !",
        },
        {
          hid: "og:image",
          property: "og:image",
          content: require("~/assets/img/og/og-facebook-graphisme.jpg"),
        },
      ],
    };
  },

  mounted() {
    window.addEventListener("scroll", this.onScroll);
    this.fadeEffect();
    this.heroAnimation();
  },
  methods: {
    onScroll(e) {
      const header = this.$refs.header;
      const sticky = header.offsetTop;

      if (window.pageYOffset > sticky) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    },

    fadeEffect() {
      const allElements = [".fade-effect-2"];
      allElements.forEach((item) => {
        this.$gsap
          .timeline({
            scrollTrigger: {
              trigger: item,
              start: "top 80%",
            },
          })
          .fromTo(
            item,
            {
              opacity: 0,
            },
            {
              opacity: 1,
              stagger: 0.3,
            }
          );
      });
    },

    heroAnimation() {
      const mm = this.$gsap.matchMedia();
      mm.add(
        {
          isDesktop: "(min-width: 1024px)",
          isMobileTablet: "(max-width: 1023px)",
        },
        (context) => {
          const { isDesktop } = context.conditions;
          this.$gsap.timeline().fromTo(
            ".text-hero",
            {
              opacity: 0,
              x: isDesktop ? "20%" : 0,
            },
            {
              opacity: 1,
              x: 0,
              duration: 1,
            }
          );
        }
      );
    },

    scrollSmooth() {
      document.documentElement.style.scrollBehavior = "smooth";
      setTimeout(() => {
        document.documentElement.style.scrollBehavior = "unset";
      }, 1000);
    },
  },
};
